export interface ApiValidationErrorBody {
  title: string;
  errors: Record<string, string[]>;
  data: any;
}

export class ApiValidationError extends Error {
  readonly title: string;
  readonly errors: Record<string, string[]>;
  readonly data: any;

  constructor(body: ApiValidationErrorBody) {
    super(body.title);
    this.name = "ApiValidationError";
    this.title = body.title;
    this.errors = body.errors ?? [];
    this.data = body.data ?? null;
  }
}
